import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { UserNamePipe } from './user-name.pipe';
import { FileSizePipe } from './file-size.pipe';

@NgModule({
  declarations: [FilterPipe, SearchPipe, ShortNamePipe, UserNamePipe, FileSizePipe],
  imports: [CommonModule],
  exports: [FilterPipe, SearchPipe, ShortNamePipe, UserNamePipe, FileSizePipe]
})

export class PipeModule { }
